import { Square } from 'lucide-react';

import { NodeShell } from './NodeShell';

export const EndNode = ({ data, selected }: { data: { label: string }; selected?: boolean }) => (
  <NodeShell
    type="end"
    icon={<Square size={16} />}
    label={data.label}
    selected={selected}
    round
    sources={[]}
  />
);
